import _ from "lodash";
import { QUEUE_CHANNEL_FN } from '../actions/types';

const INITIAL_STATE = {
    ui: {
        queueChannelFn: []
    }
}

const queueChannelFnReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case QUEUE_CHANNEL_FN.SET_QUEUE_CHANNEL_FN_DEFAULT:
            return Object.assign({}, INITIAL_STATE)
        case QUEUE_CHANNEL_FN.SET_QUEUE_CHANNEL_FN:
        case QUEUE_CHANNEL_FN.SET_QUEUE_CHANNEL_FN_VALUE:
            return Object.assign({}, {
                ...state,
                ui: {
                    ...state.ui,
                    queueChannelFn: action.queueChannelFn
                }
            })
        default:
            return state
    }
}

export default queueChannelFnReducer